import { LinearProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { AppContext } from "helpers/context";
import { useContext } from "react";

interface AddressEncodingLoadingProps {
  text: string;
}

function AddressEncodingLoading({
  text
}: Readonly<AddressEncodingLoadingProps>) {
  const [context, dispatch] = useContext(AppContext);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <LinearProgress
        color="success"
        sx={{ width: "50%", marginBottom: "10px" }}
      />
      {text}
    </Box>
  );
}

export default AddressEncodingLoading;
